import { DateTime } from "luxon";
import type { Transaction, TransactionApiDto } from "@/models/transaction";
import type { PlatformTransaction, PlatformTransactionApiDto } from "@/models/platformTransaction";
import type { Card, CardApiDto, CardSystem, CardStatus } from "@/models/card";

export function mapCard(card: CardApiDto): Card {
  const system = card.system as unknown as CardSystem;
  const status = card.status as unknown as CardStatus;
  return {
    id: card.id,
    userId: card.userId,
    clientId: card.clientId,
    name: card.name,
    system: system,
    currencyCode: card.currencyCode,
    lastDigits: card.lastDigits,
    expiryMonth: card.expiryMonth,
    expiryYear: card.expiryYear,
    status: status,
    billing: card.billing,
    createdAt: DateTime.fromISO(card.createdAt),
    updatedAt: DateTime.fromISO(card.updatedAt),
    user: undefined, // TODO: map user
    client: undefined, // TODO: map client
  };
}

export function mapTransaction(transaction: TransactionApiDto): Transaction {
  return {
    id: transaction.id ?? null,
    cardId: transaction.cardId,
    description: transaction.description,
    amount: transaction.amount,
    roundUpAmount: transaction.roundUpAmount,
    purchasedAt: DateTime.fromISO(transaction.purchasedAt) ?? null,
    rewardAmount: transaction.rewardAmount,
    rewardStatus: transaction.rewardStatus,
    card: undefined, // TODO: map card
  };
}

export function mapPlatformTransaction(platformTransaction: PlatformTransactionApiDto): PlatformTransaction {
  return {
    cardPlatformId: platformTransaction.cardPlatformId,
    dateFrom: DateTime.fromISO(platformTransaction.dateFrom),
    dateTo: DateTime.fromISO(platformTransaction.dateTo),
    platformId: platformTransaction.platformId,
    message: platformTransaction.message,
    id: platformTransaction.id,
    cardId: platformTransaction.cardId,
    amount: platformTransaction.amount,
    status: platformTransaction.status,
    type: platformTransaction.type,
    description: platformTransaction.description,
    createdAt: DateTime.fromISO(platformTransaction.createdAt),
    updatedAt: DateTime.fromISO(platformTransaction.updatedAt),
    membershipSubscriptions: platformTransaction.membershipSubscriptions,
  };
}
